import React from 'react';

const Loading = () => {
    return (<h4>Cargando...</h4>)
}

export default Loading;